module.exports = __webpack_public_path__ + "static/star-grey-879dd509fb740dabcc20025ece63fc34.png";